module.exports = __webpack_public_path__ + "static/img/princeAlbert2.dfea8a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/princeAlbert2.jpg
// module id = 124
// module chunks = 9